import type { ModalTab } from "./Modal";

interface ModalBodyProps {
  selectedTab: ModalTab;
  signedId: string;
}

export const ModalBody = ({ selectedTab }: ModalBodyProps) => (
  // TODO: Implement modal body
  <div className="flex h-full w-full max-w-7xl flex-col p-6">{selectedTab}</div>
);
